import styled from 'styled-components'
import PassworRequestdIconImage from 'icons/password-logo.svg'
import PassworRequestdLoginImage from 'icons/password-login.svg'

export const PasswordRequestWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  position: relative;
  background-color: #F2EEE8;
  
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const PasswordRequestLogo = styled.div`
  height: 30%;
  width: 100%;
  margin-bottom: 5%;
  display: block;
  border: none;
  background-image: url(${PassworRequestdIconImage});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`

export const PasswordRequestInput = styled.input`
  margin-bottom: 2%;

  width: 20%;
  height: 26px;
  padding: 0;
  color:#52403A;
  border-radius: 0;
  border: 0;
  border-bottom: 1px solid #52403A;
  background: none;
  outline: none;

  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 25.729px; /* 197.913% */
  letter-spacing: 2.144px;

  &::placeholder {
    color: #52403A;
    opacity: 1;
  }
  &.error {
    border-color: #FF0C00;
    &::placeholder {
      color: #FF0C00;
    }
  }
`

export const PasswordRequestButton = styled.div`
  color: #52403A;
  text-align: center;
  font-family: "Neuzeit Grotesk";
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 25.729px; /* 197.913% */
  letter-spacing: 2.144px;
  cursor: pointer;
  position: relative;
  padding-right: 18px;

  &::after {
    content: " ";
    display: block;
    width: 13px;
    height: 13px;
    position: absolute;
    right: 0;
    top: 25%;
    background-image: url(${PassworRequestdLoginImage});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center right;
  }
`
